import React from "react";

import "./index.scss";

export default function DupontButton(props) {
  let { type, color, disabled, onClick, customClass, children, id } = props;
  type = type || "primary";
  color = color || "primary";
  customClass = customClass || "";
  const getBtnClass = (type) => {
    let btnClass = `dupont-btn__${type}`;
    if (color) {
      btnClass = `${btnClass}--${color}`;
    }
    return btnClass;
  };

  return (
    <button
      id={id}
      className={`dupont-btn ${getBtnClass(type)} ${customClass}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
